import type { ReactNode } from "react";

/**
 * Shared overlay/card chrome for the "create a thing" modals M5b adds
 * (New Job, New Harvest, New API token) — factors out the heading style
 * already duplicated across HygieneModal/StopModal/NamePicker's add-name
 * modal, for these NEW call sites only (existing modals are left as-is;
 * retrofitting them is out of scope here).
 */
export function Modal({
  title, onClose, children,
}: { title: string; onClose: () => void; children: ReactNode }) {
  return (
    <div
      className="modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="panel modal-card">
        <h2 style={{ textTransform: "none", letterSpacing: 0, color: "var(--foreground)", fontSize: "1.15rem" }}>
          {title}
        </h2>
        {children}
      </div>
    </div>
  );
}
